<template>
    <div class="device-detail">
        <el-page-header @back="goBack" content="详情页面"></el-page-header>
        <Box :title="'预约详情'">
            <template #body>
                <table class="table">
                    <tr>
                        <td>
                            <span>特属服务对象：</span>
                            <span>{{ user_name }}</span>
                        </td>
                        <td>
                            <span>特属服务对象联系电话：</span>
                            <span>{{ user_mobile }}</span>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <span>联系人：</span>
                            <span>{{ contact_name }}</span>
                        </td>
                        <td>
                            <span>联系人联系电话：</span>
                            <span>{{ contact_mobile }}</span>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <span>特属专家：</span>
                            <span>{{ doctor_name }}</span>
                        </td>
                        <td>
                            <span>特属专家联系电话：</span>
                            <span>{{ doctor_mobile }}</span>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <span>特属服务专员：</span>
                            <span>{{ admin_user_name }}</span>
                        </td>
                        <td>
                            <span>特属服务专员电话：</span>
                            <span>{{ admin_user_mobile }}</span>
                        </td>
                    </tr>
                    <tr v-if="!meet_date || !meet_address">
                        <td colspan="2">
                            <span>期望会面时间：</span>
                            <span>{{ book_date }}</span>
                            <span>&nbsp;&nbsp;{{ half }}</span>
                        </td>
                    </tr>
                    <tr v-if="meet_date && meet_address">
                        <td colspan="2">
                          <span>会面时间：</span>
                          <span>{{ meet_date }}</span>
                          <span>&nbsp;&nbsp;{{ meet_time }}</span>
                        </td>
                    </tr>
                    <tr v-if="status_num == 4">
                        <td>
                            <span>状态：</span>
                            <span>{{ status }}</span>
                        </td>
                        <td>
                            <span>预约取消原因：</span>
                            <span>{{ remark }}</span>
                        </td>
                    </tr>
                    <tr v-if="status_num != 4">
                        <td colspan="2">
                            <span>状态：</span>
                            <span>{{ status }}</span>
                        </td>
                    </tr>
                    <tr v-if="meet_address">
                      <td colspan="2">
                        <span>会面地点：</span>
                        <span>{{ meet_address }}</span>
                      </td>
                    </tr>
                </table>
            </template>
        </Box>
        <Box :title="'操作记录'">
            <template #body>
                <el-table ref="multipleTable"
                          :data="log_data"
                          border
                          style="width: 100%">
                    <el-table-column width="120" prop="user_account" label="账号" align="center" label-class-name="label"></el-table-column>
                    <el-table-column width="100" prop="user_name" label="姓名" align="center" label-class-name="label"></el-table-column>
                    <el-table-column width="120" prop="user_role" label="账号类型" align="center" label-class-name="label"></el-table-column>
                    <el-table-column width="170" prop="create_date" label="操作日期" align="center" label-class-name="label"></el-table-column>
                    <el-table-column width="120" prop="ip_address" label="IP地址" align="center" label-class-name="label"></el-table-column>
                    <el-table-column prop="change_info" label="操作记录" align="center" label-class-name="label"></el-table-column>
                </el-table>
            </template>
        </Box>
    </div>
</template>
<script>
    import Box from "@/components/Box.vue";
    import {check} from "@/utils/checkData";
    import {getUserInfos} from "@/utils/userInfos";

    export default {
        components: {
            Box
        },
        data() {
            return {
                role_id: 0,
                child_role_id: 0,
                admin_user_name: '',
                admin_user_mobile: '',
                reservation_id: '',
                user_name: '',
                user_mobile: '',
                contact_name: '',
                contact_mobile: '',
                doctor_name: '',
                doctor_mobile: '',
                manager_name: '',
                manager_mobile: '',
                remark: '',
                status: '',
                status_num: '',
                book_date: '',
                half: '',
                log_data: [],
                meet_address: '',
                meet_date: '',
                meet_time: '',
            };
        },
        created() {
            localStorage.setItem('prev_page', 'work_detail')

            let userInfo = getUserInfos()
            this.role_id = parseInt(userInfo.role_id)
            this.child_role_id = parseInt(userInfo.child_role_id)
            if (this.$route.query.reservation_id) {
                this.reservation_id = this.$route.query.reservation_id;
            } else {
                var params = this.$route.params;
                this.reservation_id = params.reservation_id;
            }


            this.reservationDetail();
        },
        methods: {
            goBack() {
                window.history.go(-1);
                return false;
            },
            reservationDetail() {
                let params = {
                    servername: 'Ruyi_AdminWorkbenchServices',
                    method: 'reservationDetail',
                    params: {
                        reservation_id: this.reservation_id
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    if (res.data.data.detail) {
                        this.user_name = res.data.data.detail.user_name;
                        this.user_mobile = res.data.data.detail.user_mobile;
                        this.contact_name = res.data.data.detail.contact_name;
                        if (res.data.data.detail.user_id == res.data.data.detail.contact_id) {
                            this.contact_mobile = res.data.data.detail.user_mobile;
                        } else {
                            this.contact_mobile = res.data.data.detail.contact_mobile;
                        }

                        this.doctor_name = res.data.data.detail.doctor_name;
                        this.doctor_mobile = res.data.data.detail.doctor_mobile;
                        this.manager_name = res.data.data.detail.manager_name;
                        this.manager_mobile = res.data.data.detail.manager_mobile;
                        this.admin_user_name = res.data.data.detail.admin_user_name;
                        this.admin_user_mobile = res.data.data.detail.admin_user_mobile;
                        this.remark = res.data.data.detail.remark;
                        this.meet_date = this.dateToWeek(res.data.data.detail.meet_date);

                        if (res.data.data.detail.meet_time) {
                            this.meet_time = res.data.data.detail.meet_time;
                        }

                        this.meet_address = res.data.data.detail.address_info;
                        this.status_num = res.data.data.detail.status;
                        switch (res.data.data.detail.status) {
                            case '1':
                                this.status = '预约处理';

                                break;
                            case '2':
                                this.status = '等待会面';
                                break;
                            case '3':
                                this.status = '会面完成';
                                break;
                            case '4':
                                this.status = '会面中断';
                                break;
                        }
                        this.book_date = this.dateToWeek(res.data.data.detail.book_date);
                        this.half = res.data.data.detail.half;
                    }
                    for (var i = 0; i < res.data.data.log.length; i++) {
                        switch (res.data.data.log[i].user_role) {
                            case '1':
                                res.data.data.log[i].user_role = '特属服务对象'
                                break;
                            case '2':
                                res.data.data.log[i].user_role = '子账号'
                                break;
                            case '3':
                                res.data.data.log[i].user_role = '特属专家'
                                break;
                            case '4':
                                res.data.data.log[i].user_role = '陪诊护士'
                                break;
                            case '5':
                                res.data.data.log[i].user_role = '运营'
                                break;
                            case '11':
                                res.data.data.log[i].user_role = '后台管理员'
                                break;
                        }
                    }
                    this.log_data = res.data.data.log;
                    this.$store.commit("websocket/SET_MESSAGE",this.reservation_id);

                });
            },
            dateToWeek(time) {
                if (!time) {
                    return ;
                }
              let week;
              let num = new Date(time).getDay();
              switch (num) {
                  case 6:
                      week="周六";
                      break;
                  case 5:
                      week="周五";
                      break;
                  case 4:
                      week="周五";
                      break;
                  case 3:
                      week="周五";
                      break;
                  case 2:
                      week="周五";
                      break;
                  case 1:
                      week="周五";
                      break;
                  case 0:
                      week="周五";
                      break;
                  default:break;
              }
              return `${time} ${week}`;
            }
        }
    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";
</style>
